import React from 'react'
import './text-input-field.scss'

const TextInputField = ({
  inputIcon,
  type,
  name,
  placeholder,
  secondaryPlaceholder,
  value = '',
  isRequired = false,
  error = '',
  showError = true,
  isSubmitting = false,
  sublabel = '',
  rightIcon = null,
  customError,
  onBlur,
  onChange,
  ...props
}) => {
  return (
    <div className={'input-col-wrapper' + (inputIcon ? ' has-icon ' : '')}>
      <div className={'input-box ' + (error && isSubmitting ? 'input-error' : '')}>
        {inputIcon !== null && inputIcon}
        <input type={type} name={name} value={value} onBlur={onBlur} onChange={onChange} {...props} className={error && isSubmitting ? 'input-error' : ''} />
        <div className="placeholder">
          {placeholder}
          <span className="secondary-placeholder">{secondaryPlaceholder}</span>
          {isRequired && <span>*</span>}
        </div>
        {rightIcon !== null && rightIcon}
        {/* { isSubmitting && ( error
                    ? <ErrorCircleActiveIcon className="user-icon error-icon" /> 
                    : value ? <CheckCircleFilledIcon className="user-icon success-icon" /> : ''
                    )
                } */}
      </div>
      {sublabel && <div className="sub-label">{sublabel}</div>}
      {error && !customError && isSubmitting && showError && <div className="error-message">{error}</div>}
      {error && customError && isSubmitting && showError && <div className="error-message">{customError}</div>}
    </div>
  )
}

export default TextInputField
